module.exports = __webpack_public_path__ + "img/d2.f7b1786c.png";